export default __webpack_public_path__ + "static/media/lock.b346ef68.png";